// Form Module
//
//
//
//
//
//
export function initForm() {
    

    /////////////////////////////////////////////////////////////////
    // DATENSCHUTZ CHECKBOX
    /////////////////////////////////////////////////////////////////


    document.querySelectorAll('form').forEach(form => {
    const checkbox = form.querySelector('.datenschutz-checkbox');
    const submitButton = form.querySelector('.formsend-button');

    if (checkbox && submitButton) {
        // Set initial state
        submitButton.disabled = !checkbox.checked;
        submitButton.classList.add('button--disabled');

        checkbox.addEventListener('change', function() {
            // Find the submit button within the same form as this checkbox
            const formSubmitButton = this.closest('form').querySelector('.formsend-button');
            formSubmitButton.disabled = !this.checked;
            formSubmitButton.classList.toggle('button--disabled', !this.checked);
            });
        }
    });


/////////////////////////////////////////////////
// Adresse suchen (Photon API, pro .address-container)
//////////////////////////////////////////////////

function initAddressContainer(container) {
    const input = container.querySelector('[data-address-input]') ?? container.querySelector('#addressForm');
    const suggestions = container.querySelector('[data-address-suggestions]') ?? container.querySelector('#suggestions');
    const valueField = container.querySelector('[data-address-value]') ?? document.getElementById('addressValue');
    const streetField = container.querySelector('[data-address-street]') ?? document.getElementById('street');
    const postcodeField = container.querySelector('[data-address-postcode]') ?? document.getElementById('postcode');
    const cityField = container.querySelector('[data-address-city]') ?? document.getElementById('city');
    const countryField = container.querySelector('[data-address-country]') ?? document.getElementById('country');

    if (!input || !suggestions || !valueField) {
        return;
    }

    input.addEventListener('input', async () => {
        const query = input.value;

        if (query.length < 3) {
            suggestions.style.display = 'none';
            return;
        }

        try {
            const res = await fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&limit=5&lang=de`);

            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }

            const data = await res.json();
            suggestions.innerHTML = '';

            if (data.features && data.features.length > 0) {
                data.features.forEach((feature) => {
                    const li = document.createElement('li');
                    const props = feature.properties;

                    let displayText = '';
                    if (props.street && props.housenumber) {
                        displayText = `${props.street} ${props.housenumber}`;
                    } else if (props.street) {
                        displayText = props.street;
                    } else if (props.name) {
                        displayText = props.name;
                    }

                    if (props.city) {
                        displayText += `, ${props.city}`;
                    }
                    if (props.postcode) {
                        displayText += ` ${props.postcode}`;
                    }

                    li.textContent = displayText || props.label || 'Unnamed location';

                    li.addEventListener('click', () => {
                        let fullAddress = '';
                        if (props.street && props.housenumber) {
                            fullAddress = `${props.street} ${props.housenumber}`;
                        } else if (props.street) {
                            fullAddress = props.street;
                        } else if (props.name) {
                            fullAddress = props.name;
                        }

                        if (props.city) {
                            fullAddress += `, ${props.city}`;
                        }
                        if (props.postcode) {
                            fullAddress += ` ${props.postcode}`;
                        }
                        if (props.country) {
                            fullAddress += `, ${props.country}`;
                        }

                        input.value = fullAddress;
                        valueField.value = fullAddress;

                        const street = props.street || props.name || '';
                        const housenumber = props.housenumber || '';

                        if (streetField) {
                            streetField.value = street + (housenumber ? ' ' + housenumber : '');
                        }
                        if (postcodeField) {
                            postcodeField.value = props.postcode || '';
                        }
                        if (cityField) {
                            cityField.value = props.city || props.name || '';
                        }
                        if (countryField) {
                            countryField.value = props.country || '';
                        }

                        suggestions.style.display = 'none';
                    });

                    suggestions.appendChild(li);
                });

                suggestions.style.display = 'block';
            } else {
                suggestions.style.display = 'none';
            }
        } catch (error) {
            console.error('Error fetching address suggestions:', error);
            suggestions.style.display = 'none';
        }
    });

    document.addEventListener('click', (event) => {
        if (!container.contains(event.target)) {
            suggestions.style.display = 'none';
        }
    });
}

if (document.querySelectorAll('.address-container').length > 0) {
    document.querySelectorAll('.address-container').forEach(initAddressContainer);
}



    /////////////////////////////////////////////////
    // Euro-Input Form Field
    //////////////////////////////////////////////////
  
  
  if (document.querySelectorAll('.input-with-symbol').length > 0) {
    
    const currencyInputs = document.querySelectorAll('.input-with-symbol input');
    
    currencyInputs.forEach(input => {
      // Format number on input
      input.addEventListener('input', function(e) {
        // Remove all non-digit characters
        let value = this.value.replace(/[^\d]/g, '');
        
        // Format with thousand separators
        if (value.length > 0) {
          value = parseInt(value).toLocaleString('de-DE');
        }
        
        this.value = value;
      });
      
      // Format number on blur
      input.addEventListener('blur', function(e) {
        let value = this.value.replace(/[^\d]/g, '');
        if (value.length > 0) {
          this.value = parseInt(value).toLocaleString('de-DE');
        }
      });
      
      // Remove formatting before form submission
      const form = input.closest('form');
      if (form) {
        form.addEventListener('submit', function(e) {
          input.value = input.value.replace(/[^\d]/g, '');
        });
      }
    });
  }




    // END OF MODULE
    console.log("Mega Friendly Form-Module initialized");
}